import _uniqWith from 'lodash/uniqWith'
import _isEqual from 'lodash/isEqual'
import _orderBy from 'lodash/orderBy'
import DOMPurify from 'dompurify'
import util from './../../../elements'

export default {
    language(state) {
        let l = (state.info.company.language != '') ? state.info.company.language : 'en-US'
        return l.includes('-') ? l : l + '-' + l
    },
    country(state) {
        return (state.info.company.language != '') ? state.info.company.language.split('-')[1] : 'US'
    },
    currency(state) {
        return (state.info.company.currency != '') ? state.info.company.currency : 'USD'
    },
    timezone(state) {
        return (state.info.company.timezone != '') ? state.info.company.timezone : 'UTC'
    },
    trans(state) {
        return function (key) {
            return state.template.translations.hasOwnProperty(key) ? state.template.translations[key] : null
        }
    },
    classes(state) {
        return function (key) {
            let print_key = key == 'options' || key == 'calculated' ? 'input' : key
            let c = [
                'text--color-' + state.theme.elements[key].color,
                'text--font-' + state.theme.elements[key].font,
                'text--size-' + state.theme.elements[key].size,
                'print--size-' + state.theme.print.elements[print_key].size,
                'print--color-' + state.theme.print.elements[print_key].color
            ]
            if (key == 'input') { c.push('bg--element border--element'); }
            if (key == 'calculated') { c.push('bg--calculated border--calculated'); }

            return c.join(" ")
        }
    },
    formatted(state, getters) {
        return function (element) {
            let d = state.template.elements.find(e => e.id == element.definition)
            let defaults = { l: getters.language, t: getters.timezone, c: getters.currency }
            if (d.type.toUpperCase() == 'DROPDOWN' || d.type.toUpperCase() == 'OPTION') {
                d = { ...d, values: getters.dynamicValues(d) }
            }
            return d && element.value ? util[d.type.toUpperCase()].format(d, element.value, defaults) : null
        }
    },
    formatterNumeric(state, getters) {
        return function (precision) {
            let language = getters['language']
            let options = { minimumFractionDigits: precision, maximumFractionDigits: precision }
            return new Intl.NumberFormat([language, language.split("-")[0], language.split("-")[1]], options)
        }
    },
    formatterDate(state, getters) {
        return function (timezone) {
            let language = getters['language']
            return new Intl.DateTimeFormat([language, language.split("-")[0], language.split("-")[1]], { timeZone: timezone })
        }
    },
    currencysymbol(state, getters) {
        return function (currency) {
            return window.Countries && window.Countries.symbols() && window.Countries.symbols().hasOwnProperty(currency)
                ? window.Countries.symbols()[currency] : currency
        }
    },
    dateformat(state, getters) {
        return function (timezone) {
            try {
                return getters.formatterDate(timezone).formatToParts().map(({ type, value }) => {
                    if (type == 'year') { return 'YYYY' }
                    if (type == 'month') { return 'MM' }
                    if (type == 'day') { return 'DD' }
                    if (type == 'literal') { return encodeURI(value) == '%E2%80%8F/' ? '/' : value }
                }).reduce((s, p) => s + p)
            } catch (error) {
                return 'MM/DD/YYYY'
            }
        }
    },
    smartlink(state, getters) {
        return function (key, element, type) {
            let el = getters['dataElement']({ id: element.panel }, { id: element.group }, { id: key })
            if (el && el.value && type == 'url') {
                let pattern = new RegExp('^(https?:\\/\\/)?' +
                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' +
                    '((\\d{1,3}\\.){3}\\d{1,3}))' +
                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
                    '(\\?[;&amp;a-z\\d%_.~+=-]*)?' +
                    '(\\#[-a-z\\d_]*)?$', 'i');
                if (pattern.test(el.value)) {
                    return el.value
                }
            }
            if (el && el.value && type == 'file') {
                let d = el.value instanceof Array ? el.value.map((v, i) => { return v.name ? el.id + '/' + i + '/' + v.name : null }) : []
                let url = d.reverse().find((v) => { return v != null })
                if (url) {
                    return url
                }
            }
            if (el && el.value && type == 'pdf') {
                let d = el.value instanceof Array ? el.value.map((v, i) => {
                    if (v.name && v.name.substr(v.name.lastIndexOf('.') + 1).toLowerCase() == 'pdf') {
                        return el.id + '/' + i + '/' + v.name
                    }
                    return null
                }) : []
                let url = d.reverse().find((v) => { return v != null })
                if (url) {
                    return url
                }
            }
            return '';
        }
    },
    readonly(state, getters) {
        return function (definition, notempty) {
            return (state.preview == true && state.complete == true)
                || (getters.options(definition, 'readonly') == true && state.preview == false && notempty)
                || state.type == 'api-engagement'
                || (definition.type != 'ELEMENTSIGNATURE' && getters.signedByAnotherSigner)
        }
    },
    options(state, getters) {
        return function (definition, value) {
            return definition.options && definition.options.hasOwnProperty(value) ? definition.options[value] : null
        }
    },
    defaultValue(state, getters) {
        return function (id) {
            let el = state.template.elements.find(e => e.id == id)
            if (el && el.options && el.options.hasOwnProperty('default_value') && el.options.default_value) {
                let value = el.options.default_value
                if (value.constructor.name == 'Array') {
                    return value
                } else {
                    value = getters.macro(value).replace(/(<([^>]+)>)/ig, '')
                    if (value) {
                        return value
                    }
                }
            }
            return null
        }
    },
    macro(state, getters) {
        return function (value) {
            if (!value || typeof value != 'string') return DOMPurify.sanitize(value)
            let result = DOMPurify.sanitize(value)
            try {
                let macros = {}
                let language = getters['language']
                let formatter = Intl.DateTimeFormat([language, language.split("-")[0], language.split("-")[1]])
                let names = _orderBy(state.members, ['active'], ['desc']).map(m => m.name && m.name != 'Anonymous' ? m.name : '')
                let fnames = _orderBy(state.members, ['active'], ['desc']).map(m => m.first_name && m.first_name != 'Anonymous' ? m.first_name : '')
                let emails = _orderBy(state.members, ['active'], ['desc']).map(m => m.email ? m.email : '')
                let hname = names.length > 1 ? names.join(" & ") : names.join("")

                if (state.members[0].account) {
                    hname = state.members[0].account
                }

                let mData = {
                    clientname: names.length > 0 ? names[0] : '',
                    clientfirstname: fnames.length > 0 ? fnames[0] : '',
                    clientemail: emails.length ? emails[0] : '',
                    coclientname: names.length > 1 ? names[1] : '',
                    coclientfirstname: fnames.length > 1 ? fnames[1] : '',
                    name: hname,
                    shortname: hname.split(" & ").map(m => m.split(" ")[0]).join(" & "),
                }

                state.macros.forEach(m => {
                    macros[m.key] = m.getter && mData.hasOwnProperty(m.getter) ? mData[m.getter] : m.value
                })

                macros['today'] = decodeURI(encodeURI(formatter.format(Date.now())).replaceAll('%E2%80%8F/', '/'))
                macros['form.created'] = state.created ? formatter.format(Date.parse(state.created.replace(" ", "T") + 'Z')) : ''
                macros['form.created'] = decodeURI(encodeURI(macros['form.created']).replaceAll('%E2%80%8F/', '/'))
                macros['advisor.slug'] = state.info.user.name.replace(/[^a-z0-9]/gi, '')
                macros['company.slug'] = state.info.company.name.replace(/[^a-z0-9]/gi, '')

                if (state.template.package) {
                    state.template.package.forEach(item => {
                        if (item) {
                            if (item.type == 'TEXT') {
                                macros['package.' + item.id] = item.value ? item.value : '&nbsp;'
                            }
                            if (item.type == 'IMAGE') {
                                macros['package.' + item.id] = item.value ? '<img src="' + item.value + '" border="0" />' : '&nbsp;'
                            }
                        }
                    })
                }
                Object.keys(macros).forEach(k => {
                    result = result.replace(new RegExp(('[%' + k + '%]').replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'), 'g'), macros[k]);
                })

                if (state.type === 'engagement')
                {
                    result = result.replace(/\[%[^\]]+%\]/g, ' ');
                }

            } catch (error) {
                console.error(error)
                return result
            }

            return result
        }
    },
    identification(state) {
        let def = {
            first_name: state.template.elements.find(el => el.connection == 'ffca48cd-45ae-4695-9388-c10aa99f13e8'),
            last_name: state.template.elements.find(el => el.connection == '90cc0d96-1c41-483a-aeba-5dcbff12f3e7'),
            email: state.template.elements.find(el => el.connection == '95edc940-5263-4517-986f-783d56077110'),
        }

        return def.first_name || def.last_name || def.email ? def : null
    },
    dataIdentification(state, getters) {
        return function (definition) {
            if (getters.identification) {
                if (getters.identification.first_name && getters.identification.first_name.id == definition) {
                    return 'first_name'
                }
                if (getters.identification.last_name && getters.identification.last_name.id == definition) {
                    return 'last_name'
                }
                if (getters.identification.email && getters.identification.email.id == definition) {
                    return 'email'
                }
            }
            return null
        }
    },
    validateEachPanel(state) {
        return (state.type != 'engagement' || state.preview == false)
            && state.template.options.hasOwnProperty('validate_panels') && state.template.options.validate_panels == true
    },
    dataPanels(state) {
        return function (dPanel) {
            if (dPanel && dPanel.type == 'INDIVIDUAL') return state.panels.filter(p => p.type != 'ACCOUNT')
            if (dPanel && dPanel.type == 'ACCOUNT') return state.panels.filter(p => p.type == 'ACCOUNT')

            return [{ id: null, type: 'STATIC' }]
        }
    },
    visiblePanel(state) {
        return function (dPanel) {
            if (!dPanel) return false
            if (dPanel.hasOwnProperty('print_visibility')) {
                let v = dPanel.print_visibility
                if (v == 'preview' && (state.preview != true || state.printing == true)) {
                    return false
                }
                if (v == 'screen' && state.printing == true) {
                    return false
                }
                if (v == 'print' && state.printing == false) {
                    return false
                }
            }

            if (!dPanel.hasOwnProperty('visibility') || !dPanel.visibility) {
                return true
            }

            let vElement = state.template.elements.find(e => e.id == dPanel.visibility.field.split('|')[2])
            if (!vElement) {
                return true
            }

            let f = util[vElement.type.toUpperCase()]
            if (!f) {
                return true
            }

            return state.elements.filter(e => {
                return e.definition == vElement.id && f.compare(e.value, dPanel.visibility.operator, dPanel.visibility.value)
            }).length > 0
        }
    },
    dataGroups(state) {
        return function (aPanel, dGroup) {
            let result = (state.groups.length > 0) ? state.groups.slice(0, 1) : [{ id: null }]
            if (dGroup.type == 'MULTIPLE') {
                let elements = state.template.elements.filter(e => e.group == dGroup.id).map(e => e.id)
                let ids = state.elements.filter(e => elements.indexOf(e.definition) !== -1 && e.panel == aPanel.id).map(e => e.group)
                let groups = state.groups.filter(g => ids.indexOf(g.id) !== -1)
                result = groups.length > 0 ? groups : result
            }

            return result
        }
    },
    visibleGroup(state) {
        return function (aPanel, dGroup) {
            if (!dGroup) return false
            if (dGroup.hasOwnProperty('print_visibility')) {
                let v = dGroup.print_visibility
                if (v == 'preview' && (state.preview != true || state.printing == true)) {
                    return false
                }
                if (v == 'screen' && state.printing == true) {
                    return false
                }
                if (v == 'print' && state.printing == false) {
                    return false
                }
            }

            if (!dGroup.hasOwnProperty('visibility') || !dGroup.visibility) {
                return true
            }

            let dPanel = state.template.panels.find(p => p.id == dGroup.panel)
            let vPanel = state.template.panels.find(p => p.id == dGroup.visibility.field.split('|')[0])
            let vElement = state.template.elements.find(e => e.id == dGroup.visibility.field.split('|')[2])
            if (!vElement || !vPanel) {
                return true
            }

            let f = util[vElement.type.toUpperCase()]
            if (!f) {
                return true
            }

            if (aPanel && dPanel.type == vPanel.type) {
                return state.elements.filter(e => {
                    return e.definition == vElement.id && e.panel == aPanel.id
                        && f.compare(e.value, dGroup.visibility.operator, dGroup.visibility.value) == true
                }).length > 0
            }

            return state.elements.filter(e => {
                return e.definition == vElement.id && f.compare(e.value, dGroup.visibility.operator, dGroup.visibility.value)
            }).length > 0
        }
    },
    dataElement(state) {
        return function (aPanel, aGroup, dElement) {
            return state.elements.find(e => e.panel == aPanel.id && e.group == aGroup.id && e.definition == dElement.id)
        }
    },
    visibleElement(state) {
        return function (aPanel, aGroup, dElement) {
            if (!dElement) return false
            if (dElement.hasOwnProperty('print_visibility')) {
                let v = dElement.print_visibility
                if (v == 'preview' && (state.preview != true || state.printing == true)) {
                    return false
                }
                if (v == 'screen' && state.printing == true) {
                    return false
                }
                if (v == 'print' && state.printing == false) {
                    return false
                }
            }

            if (!dElement.hasOwnProperty('visibility') || !dElement.visibility) {
                return true
            }

            let dGroup = state.template.groups.find(g => g.id == dElement.group)
            let dPanel = state.template.panels.find(p => p.id == dGroup.panel)
            let vPanel = state.template.panels.find(p => p.id == dElement.visibility.field.split('|')[0])
            let vGroup = state.template.groups.find(g => g.id == dElement.visibility.field.split('|')[1])
            let vElement = state.template.elements.find(e => e.id == dElement.visibility.field.split('|')[2])
            if (!vElement || !vGroup || !vPanel) {
                return true
            }

            let data = state.elements.filter(e => e.definition == vElement.id)
            if (aPanel && dPanel.type == vPanel.type) {
                data = data.filter(e => e.panel == aPanel.id)
            }
            if (aGroup && dGroup.id == vGroup.id) {
                data = data.filter(e => e.group == aGroup.id)
            }

            let f = util[vElement.type.toUpperCase()]
            if (!f) {
                return true
            }

            return data.filter(e => {
                return f.compare(e.value, dElement.visibility.operator, dElement.visibility.value)
            }).length > 0
        }
    },
    address(state, getters) {
        return function (definition, element) {
            let defs = state.template.elements.filter(e => {
                return e.type == 'ADDRESS' && e.options
                    && e.options.copy == true
                    && e.options.address1 == definition.options.address1
                    && e.options.address2 == definition.options.address2
                    && e.options.city == definition.options.city
                    && e.options.zip == definition.options.zip
                    && e.options.state == definition.options.state
                    && e.options.country == definition.options.country
            })

            let keys = defs.map(e => { return e.id })
            let els = state.elements.filter(e => {
                return keys.indexOf(e.definition) != -1 && e.id != element.id && e.value
            }).map(e => {
                let def = defs.find(d => d.id == e.definition)
                let dGroup = state.template.groups.find(g => g.id == def.group)
                let dPanel = state.template.panels.find(p => p.id == dGroup.panel)
                let owner = null
                if (dPanel.type != 'ACCOUNT') {
                    let panel = state.panels.find(p => p.id == e.panel && p.type != 'ACCOUNT')
                    owner = state.members.find(m => m.type == panel.type)
                    owner = owner ? owner.name : null
                } else {
                    let panel = state.panels.find(p => p.id == e.panel && p.type == 'ACCOUNT')
                    let group = state.groups.find(g => g.id == e.group)
                    let formatted = null
                    if (dGroup.row) {
                        let element = getters['dataElement'](panel, group, { id: dGroup.row })
                        formatted = element ? getters['formatted'](element) : null
                    }
                    owner = formatted ? formatted : getters['macro'](dGroup.title)
                }
                return { label: getters['macro'](def.title), owner: owner, value: e.value }
            })
            return els.length > 1 ? _uniqWith(els, (el1, el2) => _isEqual(el1.value, el2.value)) : els
        }
    },
    dynamicItems(state, getters) {
        return function (group, element) {
            let definition = state.template.elements.find(e => e.id == element)
            let data = []
            if (definition) {
                if (definition.type.toUpperCase() == 'DROPDOWN' || definition.type.toUpperCase() == 'OPTION') {
                    definition.values = getters.dynamicValues(definition)
                }
                let defaults = { l: getters.language, t: getters.timezone, c: getters.currency }
                data = state.elements.filter(e => e.definition == definition.id && e.value && e.value.toString().trim().length > 0).map(e => {
                    return {
                        value: group + '|' + e.id,
                        label: util[definition.type.toUpperCase()].format(definition, e.value, defaults)
                    }
                })
            }
            if (data.length == 0 && state.dynamic.hasOwnProperty(element)) {
                data = state.dynamic[element].filter(e => e.definition == element && e.value && e.value.toString().trim().length > 0).map(e => {
                    return {
                        value: group + '|' + e.id,
                        label: e.value
                    }
                })
            }

            return data
        }
    },
    dynamicValues(state, getters) {
        return function (definition) {
            try {
                let result = []
                definition.options.structure.groups.forEach(g => {
                    if (g.scope != 'static' && g.items) {
                        result = result.concat(getters.dynamicItems(g.items[0].value, g.items[0].label))
                    }
                })
                return result
            } catch (error) {
                return []
            }
        }
    },
    customElements(state, getters) {
        return function () {
            return state.template.elements.filter(e => e.options && e.options.custom_id && e.options.custom_id != 'cfs_report')
        }
    },
    customElement(state, getters) {
        return function (id) {
            return state.template.elements.find(e => e.options && e.options.custom_id && e.options.custom_id == id)
        }
    },
    signedByAnotherSigner(state, getters) {
        let signedIn = state.members.find(m => m.active == true)
        let signatures = signedIn ? state.signatures.filter(s => s.value && s.email != signedIn.email) : []
        return signatures.length > 0
    },
    security(state) {
        return function (key) {
            return state.info.company.security.hasOwnProperty(key) ? state.info.company.security[key] : null
        }
    },
}
